/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

import { createContext } from 'react';
var TextAncestorContext = /*#__PURE__*/createContext(false);
export default TextAncestorContext;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/exports/Text/TextAncestorContext.js